import { Box, Typography, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { fieldLabels, fieldTooltips } from '../constants/fieldLabels';
import { BRAND_TABLE_TEXT_COLOR } from '../styles/tableColors';

interface FieldRowProps {
  fieldKey: string;
  value: React.ReactNode;
  format?: (value: unknown) => React.ReactNode;
  showLabel?: boolean;
  customLabel?: string;
  customTooltip?: string;
}

const FieldRow: React.FC<FieldRowProps> = ({ 
  fieldKey, 
  value, 
  format, 
  showLabel = true,
  customLabel,
  customTooltip
}) => {
  // Fallback: customLabel > fieldLabels > Salesforce label > fieldKey
  let salesforceLabel: string | undefined = undefined;
  if (
    typeof value === 'object' &&
    value !== null &&
    'salesforceLabels' in value &&
    value.salesforceLabels &&
    typeof value.salesforceLabels === 'object' &&
    value.salesforceLabels !== null &&
    (value.salesforceLabels as Record<string, string>)[fieldKey]
  ) {
    salesforceLabel = (value.salesforceLabels as Record<string, string>)[fieldKey];
  }
  const label = customLabel || fieldLabels[fieldKey as keyof typeof fieldLabels] || salesforceLabel || fieldKey;
  const tooltip = customTooltip || fieldTooltips[fieldKey as keyof typeof fieldTooltips];

  const displayValue = format ? format(value) : value;

  return (
    <Box sx={{ 
      display: 'grid', 
      gridTemplateColumns: '1fr auto',
      gap: 2,
      alignItems: 'center',
      py: 1
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {showLabel && (
          <Typography
            sx={{
              color: BRAND_TABLE_TEXT_COLOR,
              fontSize: '16px !important',
              fontFamily: "'Libre Franklin', sans-serif",
              fontWeight: 400,
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              textAlign: 'left',
              '&.MuiTypography-root': {
                fontSize: '16px !important'
              }
            }}
          >
            {label}
            {tooltip && (
              <Tooltip title={tooltip}>
                <InfoOutlinedIcon sx={{ fontSize: '16px !important', verticalAlign: 'middle', color: '#bdbdbd', cursor: 'pointer' }} />
              </Tooltip>
            )}
          </Typography>
        )}
      </Box>
      <Typography
        sx={{
          color: BRAND_TABLE_TEXT_COLOR,
          fontWeight: 500,
          fontSize: '16px !important',
          fontFamily: "'Libre Franklin', sans-serif",
          textAlign: 'right',
          minWidth: 'fit-content',
          '&.MuiTypography-root': {
            fontSize: '16px !important'
          }
        }}
      >
        {displayValue}
      </Typography>
    </Box>
  );
};

export default FieldRow; 
